<template>
  <div class="container">
    <div class="slider-promos">
      <div class="page">
        <div class="liveApp" v-if="!loading" @mouseenter="stopRotation"
             @mouseleave="startRotation">
          <div class="navprev"><a @click="increment(-1)"><img src="/static/img/triangle-next-prev.svg"></a></div>
          <div class="navnext"><a @click="increment(1)"><img src="/static/img/triangle-next-prev.svg"></a></div>
          <div class="images">
            <div class="single_slide"
                 v-for="(image, index) in pictures"
                 :key="image.absolute_path"
                 :class="{ active: index === currentIndex}"
                 :index="index"
                 :item="image"
                 @click="redirectBusiness(texts[index % texts.length].href)"

            >
              <div class="imgslider">
                <div class="slider_image" :class="{loaded: isLoaded(index)}">
                  <img :src="image.absolute_path + '?w='+ Math.min((window.innerWidth - 200), 1000) +'&h=200&crop-to-fit'"
                       v-if="window.innerWidth > 768" v-on:load="handleIndexLoaded(index)" />
                  <img :src="image.absolute_path + '?w='+ Math.min((window.innerWidth), 1000) +'&h=200&crop-to-fit'"
                       v-if="window.innerWidth <= 768" v-on:load="handleIndexLoaded(index)"/>
                </div>
              </div>

              <div class="txtslide">
                <h3>
                  {{texts[index % texts.length].lines[0].toUpperCase() || ''}}
                  <br>
                  {{texts[index % texts.length].lines[1] || ''}}
                </h3>
                <p>{{texts[index % texts.length].lines[2] || ''}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="loader" v-else>
          <loader/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Loader from '../../components/loader.component'

  export default {
    name: 'home-promos',
    components: { Loader },
    data() {
      return {
        currentIndex: 0,
        window: window,
        interval: null,
        loaded: [],
        rotationCount: 0,
      };
    },
    async created() {
      this.currentIndex = 0;
      await this.$store.commit('businessSlider/SET_PICTURES', [])
      await this.$store.dispatch('businessSlider/fetch', {lang: this.$store.state.lang.currentLang});
    },
    async beforeDestroy() {
      await this.$store.commit('businessSlider/SET_PICTURES', [])
      this.currentIndex = 0;
      clearInterval(this.interval);
    },
    methods: {
      goto(index) {
        this.currentIndex = index;
      },
      isLoaded (index) {
        return this.loaded.slice(0, index + 1).reduce((c, p) => (c && p), true)
          && (
            (index === 0 || this.currentIndex > 0)
            || (
              this.currentIndex === 0
              && index === this.pictures.length - 1 && this.rotationCount > 0
            )
          );
      },
      startRotation() {
        if (this.interval) {
          return;
        }
        this.interval = setInterval(() => {
          this.rotationCount += 1;
          this.increment();
        }, this.duration);
      },
      stopRotation() {
        if (!this.interval) {
          return;
        }
        clearInterval(this.interval);
        this.interval = null;
      },
      increment(v = 1) {
        if (this.loaded.length === 0) return;
        if (this.currentIndex >= 0 && this.currentIndex < this.pictures.length + 1) {
          let nextIndex = (this.currentIndex + v) % this.pictures.length;
          if (this.loaded[nextIndex] === false) return;
          this.currentIndex = nextIndex;
        }
        if (this.currentIndex === 3 && v === 1) {
          if (this.loaded[0] === false) return;
          this.currentIndex = 0;
        }
        if (this.currentIndex === -1 && v === -1) {
          if (this.loaded[this.pictures.length - 1] === false) return;
          this.currentIndex = (this.pictures.length - 1);
        }
      },
      handleIndexLoaded (index) {
        this.loaded[index] = true;
        if (this.loaded.reduce((c,p) => (!!c && p), true)) {
          this.$forceUpdate();
          this.startRotation();
        }
      },
      redirectBusiness(link) {
        window.open(link, '_blank');
      }
    },
    watch: {
      roomPictures () {
        this.loaded = [];
        this.rotationCount = 0;
        for (let i = 0; i < this.pictures.length; i++) this.loaded.push(false);
      },
    },
    computed: mapState({
      pictures: state => state.businessSlider.pictures,
      texts: state => state.businessSlider.texts,
      loading: state => state.businessSlider.loading,
      duration: state => state.businessSlider.duration,
    }),
  };
</script>

<style scoped>
  .loader {
    height: 180px;
  }

  .bloc-promo {
    min-height: 280px;
  }

  .single_slide:not(.active) {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/home-promos.vue